var path = '/formViewer/component/supplementalFormPlaceholder.tpl.html';
var html = "<ui-form-viewer ng-if=\"row.sectionList\"\n                form-id=\"{{ ::formId }}\"\n                form-data=\"row\"\n                supplemental=\"true\"></ui-form-viewer>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;